module.exports = __webpack_public_path__ + "img/price_list_de.2c561bfd.png";